<template>
    <div class="hidden lg:block">
        <SkeletonBase
            :table="2"
            :hasTitle="true"
        />
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-0 lg:hidden">
        <div class="gray-dashed">
            <SkeletonBase
                class="lg:hidden"
                :contentCols="2"
                :content="1"
            />
        </div>
        <div class="gray-dashed items-center">
            <SkeletonBase
                class="lg:hidden"
                :contentCols="2"
                :content="1"
            />
        </div>
        <div class="gray-dashed items-center">
            <SkeletonBase
                class="lg:hidden"
                :contentCols="2"
                :content="1"
            />
        </div>
        <div class="gray-dashed items-center">
            <SkeletonBase
                class="lg:hidden"
                :contentCols="2"
                :content="1"
            />
        </div>
    </div>
</template>

<script>
import SkeletonBase from '@/components/skeletons/SkeletonBase.vue';

export default {
    components: {
        SkeletonBase,
    },
};
</script>
<style scoped lang="scss">
.gray-dashed {
    @apply border-t border-dashed border-gray-200 pt-4 pb-0;
}
</style>
